import { Navigate, Outlet } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const PrivateRoute = () => {
  const token = localStorage.getItem('authToken');

  if (!token) {
    return <Navigate to="/" replace />;
  }

  try {
    const decodedToken = jwtDecode(token);
    if (decodedToken.exp * 1000 < Date.now()) {
      localStorage.clear();
      return <Navigate to="/" replace />;
    }
  } catch (error) {
    localStorage.clear();
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;